import styled from 'styled-components';

export const AddProposalContainer = styled.div.attrs({})`
  /* topo curto: as abas ficam logo acima e nao precisam de respiro grande */
  padding: 10px 0px 0px 0px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

export const CompanyButtonContainer = styled.div.attrs({})`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: flex-end;
`;

// Motivo de a acao do rodape estar desabilitada (ex.: renegociacao que ja tem
// baixa nao pode ser cancelada), ao lado dos botoes.
export const FooterHint = styled.span.attrs({})`
  margin-right: auto;
  font-size: 12px;
  color: #718096;
`;

// Faixa de contexto que vive no cabecalho do modal, ao lado do titulo.
export const ResumoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 18px;
  min-width: 0;
`;

export const ResumoItem = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
`;

export const ResumoLabel = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  color: #718096;
  white-space: nowrap;
`;

export const ResumoValue = styled.span`
  font-size: 16px;
  color: #2d3748;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// Os dois grupos de filtro dividem a mesma linha; so quebram quando nao cabem.
export const FiltrosGrupo = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 24px;
  margin-bottom: 12px;
  flex-shrink: 0;

  @media (max-height: 800px) {
    margin-bottom: 8px;
  }
`;

export const FiltroLinha = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;

export const FiltroLabel = styled.span`
  font-size: 11px;
  text-transform: uppercase;
  color: #718096;
  min-width: 44px;
`;

export const FiltroContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const FiltroButton = styled.button`
  border: 1px solid ${(props) => (props.active ? '#2670d1' : '#e2e8f0')};
  background: ${(props) => (props.active ? '#2670d1' : '#ffffff')};
  color: ${(props) => (props.active ? '#ffffff' : '#4a5568')};
  border-radius: 16px;
  padding: 4px 14px;
  font-size: 12px;
  font-family: 'Kumbh Sans';
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.45 : 1)};
  transition: 0.2s;

  &:hover {
    border-color: ${(props) => (props.disabled ? '#e2e8f0' : '#2670d1')};
  }
`;

export const FormHint = styled.p`
  font-size: 12px;
  color: #718096;
  line-height: 1.4;
  margin: 12px 0 0 0;
`;

// Ocupa toda a altura restante da coluna: a rolagem fica aqui dentro para o
// modal nao mudar de tamanho conforme o filtro selecionado.
export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 5px;
  border-left: 2px solid #e2e8f0;
  margin-left: 10px;
  gap: 20px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

// Mantem a mesma area ocupada pela timeline nos estados de carga e vazio.
export const TimelineFallback = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TimelineItem = styled.div`
  position: relative;
  padding-left: 20px;

  &::before {
    content: '';
    position: absolute;
    left: -11px;
    top: 4px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${(props) => props.color || '#3182ce'};
    border: 2px solid #ffffff;
  }
`;

export const TimelineContent = styled.div`
  display: flex;
  flex-direction: column;
  background: #f8fafc;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const TimelineHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  flex-wrap: wrap;
`;

export const TimelineTag = styled.span`
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 600;
  color: #ffffff;
  background: ${(props) => props.color || '#3182ce'};
  border-radius: 4px;
  padding: 2px 6px;
`;

export const TimelineAuthor = styled.strong`
  color: #2d3748;
  font-size: 14px;
`;

export const TimelineDate = styled.span`
  color: #718096;
  font-size: 12px;
`;

export const TimelineText = styled.span`
  font-size: 15px;
  color: #4a5568;
  line-height: 1.4;
`;

export const TimelineDetail = styled.span`
  font-size: 13px;
  color: #718096;
  margin-top: 6px;
`;

export const SeparadorColuna = styled.hr`
  border: none;
  border-top: 1px solid #e2e8f0;
  margin: 16px 0 0 0;
  width: 100%;
  flex-shrink: 0;
`;

export const TopoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

// Os tres paineis ficam montados e alternam por CSS: trocar de aba nao pode
// perder o que o operador ja digitou nem remontar as listas.
export const PainelAba = styled.div`
  display: ${(props) => (props.$ativo ? 'flex' : 'none')};
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;
